import React from "react";
import logodnp from "../../img/cce-color.png";
import imagenMantenimiento from "../../img/MTTO_simuladores.png";
import logoFooter from "../../img/LogoGovCo.png";
import youTubeFooter from "../../img/youtubeFooter.png";
import twitterFooter from "../../img/twitterFooter.png";
import facebookFooter from "../../img/facebookFooter.png";
import linkedinFooter from "../../img/linkedinFooter.png";
import RSSFooter from "../../img/RSSFooter.png";

import VersionApp from "./VersionApp";
export default function VistaMantenimiento() {
  return (
    <div>
      {/* Cabezote */}
      <div
        className="content"
        style={{ position: "fixed", width: "100%", top: "0px", zIndex: 999 }}
      >
        <div className="fondo-azul-sin-texto"></div>
        <div className="fondo-azul" style={{ marginBottom: "20px" }}>
          <div className="container">
            <nav
              className="navbar navbar-expand-lg navbar-light"
              style={{ paddingLeft: "0px" }}
            >
              <div className="logoGov">
                <a
                  href="https://www.gov.co/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    alt="Logo colombia compra"
                    style={{ maxWidth: "150px" }}
                    className="img-fluid logovco"
                    src="https://1a1.click/img/Logo%20govco.png"
                  />
                </a>
              </div>
            </nav>
          </div>
          <div className="container">
            <div className="fila">
              <div className="col-6 col-md-3 mr-auto">
                
              </div>
              <div className="col-6 col-md-3 ml-auto">
                <a href="https://www.colombiacompra.gov.co/">
                  <img id="logodnp" src={logodnp} alt="Logo DNP" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Contenido de mantenimiento */}
      <div
        className="container"
        style={{ minHeight: "550px", paddingTop: "160px", textAlign: "center" }}
      >
        <img
          src={imagenMantenimiento}
          alt="Mantenimiento"
          style={{ maxWidth: "400px", width: "100%" }}
        />
      </div>

      {/* Pie de página */}
      <div style={{ backgroundColor: "#0164c1" }}>
        <div className="container foot pt-4">
          <div className="fila">
            <div className="col-12 col-md-2 bd">
              <img className="img-fluid" src={logoFooter} alt="Logo Footer" />
            </div>
            <div className="col-12 col-md-6 py-4 bd">
              <h5 className="blanco">Colombia Compra Eficiente</h5>
              <p className="blanco small">
                Carrera 7 No 26 - 20 Piso 23 / Dirección General / Edificio
                Seguros Tequendama (Bogotá D.C)
                <br />
                Código Postal: 110311
                <br />
                Horario de atención: de 8:30 a.m a 4:30 p.m / Lunes a Viernes
              </p>
              <div className="fila">
                <div className="col-md-1 col-2">
                  <a
                    href="https://www.facebook.com/ColombiaCompraEficiente/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img alt="facebook" src={facebookFooter} />
                  </a>
                </div>
                <div className="col-md-1 col-2">
                  <a
                    href="https://twitter.com/colombiacompra"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img alt="twitter" src={twitterFooter} />
                  </a>
                </div>
                <div className="col-md-1 col-2">
                  <a
                    href="https://www.linkedin.com/company/colombia-compra-eficiente/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img alt="linkedin" src={linkedinFooter} />
                  </a>
                </div>
                <div className="col-md-1 col-2">
                  <a
                    href="https://www.youtube.com/channel/UC2pHOdAhZovC5vE7IsuiGbg"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img alt="youtube" src={youTubeFooter} />
                  </a>
                </div>
                <div className="col-md-1 col-2">
                  <a href="/node/22/" target="_blank" rel="noopener noreferrer">
                    <img alt="rss" src={RSSFooter} />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 py-4">
              <h6 className="blanco">Contacto de notificaciones judiciales</h6>
              <p className="blanco small">
                <a
                  className="blanco"
                  href="mailto:notificacionesjudiciales@colombiacompra.gov.co"
                >
                  notificacionesjudiciales@colombiacompra.gov.co
                </a>
                <br />
                Nit. 900514913-2
                <br /> Línea nacional gratuita: 018000520808
                <br />
                PBX: (+57) (1) 7956600
                <br /> Línea en Bogotá: (+57) (1) 7456788
              </p>
            </div>
          </div>
          <div className="col-12">
            <hr />
            <div className="d-flex flex-wrap justify-content-between">
              <p className="text-left blanco">
                &copy; {new Date().getFullYear()}. Colombia Compra Eficiente. Todos los derechos
                reservados.
              </p>
              <VersionApp />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
